import {
  CATERING,
  DELIVERY,
  DUPLICATE_LOCATION,
  GROCERY,
  MISC,
  NO_GOOGLE_MATCH,
  NO_MENU,
  NO_SCRAPABLE_WEBSITE,
  NO_WEBSITE,
  NOT_PUBLISHED_BY_ATLAS,
} from './location-exclusion-reasons'

export const BRAND_GATEWAY_TASK_SPECIFIC_EXCLUSION_REASONS = [
  GROCERY,
  CATERING,
  NO_WEBSITE,
  NO_SCRAPABLE_WEBSITE,
  MISC,
  DELIVERY,
]

export const BRAND_DEFINITION_TASK_SPECIFIC_EXCLUSION_REASONS = [
  NO_GOOGLE_MATCH,
  DUPLICATE_LOCATION,
]

export const MENU_DEFINITION_TASK_SPECIFIC_EXCLUSION_REASONS = [NO_MENU]

export const ATLAS_IMPORT_SPECIFIC_EXCLUSION_REASONS = [NOT_PUBLISHED_BY_ATLAS]
